<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Assign Devices to {{ zone.name }}</h2>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <div class="card">
          <div class="card-header bg-hub-primary text-white">Available Devices</div>
          <div class="card-block">
            <select
              multiple
              class="form-control devices-select"
              style="height: 215px;"
              v-model="selected_available_devices"
            >
              <option
                v-for="device in filtered_available_devices"
                v-bind:value="device.device_id"
                :key="device.device_id"
              >{{ (scoped_site_id === 1 ? "[" + device.site.name + "]" : "") }} {{ device.name }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-2 middle-btn-col">
        <div class="btn-group-vertical">
          <button id="ToAssignedList" type="button" class="btn btn-light" @click="toAssignedList()">
            <i class="fa fa-arrow-right fa-fw" aria-hidden="true"></i>
          </button>
          <button
            id="ToAvailableList"
            type="button"
            class="btn btn-light"
            @click="toAvailableList()"
          >
            <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="col-5">
        <div class="card">
          <div class="card-header bg-hub-primary text-white">Assigned Devices</div>
          <div class="card-block">
            <select
              multiple
              class="form-control devices-select"
              style="height: 215px;"
              v-model="selected_assigned_devices"
            >
              <option
                v-for="zone_device in zone.zone_devices"
                :key="zone_device.device_id"
                v-bind:value="zone_device.device_id"
              >{{ (scoped_site_id === 1 ? "[" + zone_device.device.site.name + "]" : "") }} {{ zone_device.device.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
        <router-link :to="{ name: 'ZoneManager' }" class="btn btn-secondary">Cancel</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: ['type', 'zone_id'],
  data: function () {
    return {
      selected_assigned_devices: [],
      selected_available_devices: []
    }
  },
  computed: {
    ...mapGetters({
      zone: 'singleZone',
      available_devices: 'availableDevices',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_available_devices: function () {
      let deviceTypes = []

      if (this.type === 'main') {
        deviceTypes = [1, 2, 3]
      } else if (this.type === 'visual') {
        deviceTypes = [5, 6]
      } else if (this.type === 'lock') {
        deviceTypes = [7]
      }
      if (this.scoped_site_id === 1) {
        return this.available_devices.filter(d =>
          deviceTypes.includes(d.device_type_id)
        )
      } else {
        return this.available_devices.filter(
          d =>
            d.site_id === this.scoped_site_id &&
            deviceTypes.includes(d.device_type_id)
        )
      }
    },
    ordered_available_devices: function () {
      return _.orderBy(this.available_devices, 'name')
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)

    this.$store.dispatch('getZone', this.zone_id)
    this.$store.dispatch('getAvailableDevices', this.zone_id)
  },
  methods: {
    toAssignedList () {
      for (let i = 0; i < this.selected_available_devices.length; i++) {
        let selectedDeviceId = this.selected_available_devices[i]
        let deviceToMove = this.available_devices.find(function (ele) {
          if (ele.device_id === selectedDeviceId) {
            return true
          }
        })
        this.zone.zone_devices.push({
          device_id: deviceToMove.device_id,
          zone_id: this.zone.zone_id,
          device: {
            name: deviceToMove.name,
            device_type_id: deviceToMove.device_type_id,
            site_id: deviceToMove.site_id,
            site: {
              name: deviceToMove.site.name
            }
          }
        })
        this.available_devices.splice(
          this.available_devices.indexOf(deviceToMove),
          1
        )
      }
    },
    toAvailableList () {
      for (let i = 0; i < this.selected_assigned_devices.length; i++) {
        let selectedDeviceId = this.selected_assigned_devices[i]
        let deviceToMove = this.zone.zone_devices.find(function (ele) {
          if (ele.device_id === selectedDeviceId) {
            return true
          }
        })
        this.available_devices.push({
          device_id: deviceToMove.device_id,
          device_type_id: deviceToMove.device.device_type_id,
          name: deviceToMove.device.name,
          site_id: deviceToMove.device.site_id,
          site: {
            name: deviceToMove.device.site.name
          }
        })
        this.zone.zone_devices.splice(
          this.zone.zone_devices.indexOf(deviceToMove),
          1
        )
      }
    },
    submit () {
      this.$store.dispatch('assignDevices', this.zone)
    }
  }
}
</script>

<style scoped>
.middle-btn-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.devices-select {
  width: 100%;
  height: 250px;
}
</style>
